const BASE_FEE = 100;
const MAX_FEE = 25000;
const FEE_PER_THOUSAND_VIEWS = 25;
const FOLLOWER_FEE_MULTIPLIER = 0.008;
const ENGAGEMENT_RATE_MULTIPLIER = 50;
const DEFAULT_ENGAGEMENT_RATE = 1.0;
const DIE_HARD_FANS_DEFAULT_VALUE = 3.5;
const AOV_DEFAULT_VALUE = 0.9;
export { BASE_FEE, MAX_FEE, FEE_PER_THOUSAND_VIEWS, FOLLOWER_FEE_MULTIPLIER, ENGAGEMENT_RATE_MULTIPLIER, DEFAULT_ENGAGEMENT_RATE, DIE_HARD_FANS_DEFAULT_VALUE, AOV_DEFAULT_VALUE, };
